/**
 * HW Size Picker — adds a variant to cart when a tile is clicked.
 * Uses the Shopify Cart API (fetch /cart/add.js).
 */
(function () {
  /*
   * Use capture phase (true) so this fires top-down BEFORE any bubbling
   * stopPropagation() calls (e.g. onclick="event.stopPropagation()" on the
   * .hw-size-picker container). Bubbling-phase delegation at document would
   * never fire because the container stops propagation before the event
   * reaches document.
   */
  document.addEventListener('click', function (event) {
    const tile = event.target.closest('.hw-size-picker__tile');
    if (!tile) return;
    if (tile.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = tile.dataset.variantId;
    if (!variantId) return;

    tile.setAttribute('aria-busy', 'true');
    tile.classList.add('hw-size-picker__tile--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        tile.classList.remove('hw-size-picker__tile--loading');
        tile.classList.add('hw-size-picker__tile--added');
        tile.removeAttribute('aria-busy');

        /* Dispatch cart update event so theme cart drawer/counter refreshes */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(function () {
          tile.classList.remove('hw-size-picker__tile--added');
        }, 1500);
      })
      .catch(function () {
        tile.classList.remove('hw-size-picker__tile--loading');
        tile.removeAttribute('aria-busy');
      });
  }, true); /* capture: true */
})();
